import useQueryParam from "services/hooks/useQueryParam";
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";
import { Breadcrumb } from "ui/components/Breadcrumb";
import { FINANCIAL_OVERVIEW_PAGE_TITLE } from "ui/components/PageTitle/consts";
import { Routes as ReportRoutes } from "ui/modules/reports/navigation";
import {
  DashboardDateRangeProvider,
  DashboardDateRangeChip,
} from "ui/modules/dashboard/pages/DashboardPage/context/DashboardDateRangeContext";
import TabMenu from "./components/TabMenu/TabMenu";
import { DEFAULT_FINANCIAL_TAB, FINANCIAL_TABS, FINANCIAL_TAB_VALUES } from "./consts";
import { FinancialOverviewPageCmp, FinancialOverviewPageProps } from "./types";

const FinancialOverviewPage: FinancialOverviewPageCmp = (
  _props: FinancialOverviewPageProps
) => {
  // Aktivni tab živi u `?tab=`, pa preživi osvježavanje i dijeljenje linka.
  const [activeTab, setActiveTab] = useQueryParam(
    "tab",
    DEFAULT_FINANCIAL_TAB,
    FINANCIAL_TAB_VALUES
  );

  const active =
    FINANCIAL_TABS.find((tab) => tab.value === activeTab) ?? FINANCIAL_TABS[0];

  return (
    <DashboardDateRangeProvider>
      <div>
        <div className="bg-white rounded-t-md">
          <PageHeader>
            <PageTitle
              title="Financijski pregled"
              icon={FINANCIAL_OVERVIEW_PAGE_TITLE.icon}
              iconColor={FINANCIAL_OVERVIEW_PAGE_TITLE.iconColor}
            />
            <Breadcrumb />
          </PageHeader>
          <TabMenu activeTab={active.value} onTabChange={setActiveTab} />
        </div>

        {/* Odabir razdoblja stoji u sadržaju jer mijenja podatke svih tabova, a ne stranicu. */}
        <div className="flex justify-end px-0 pt-4 xl:px-6">
          <DashboardDateRangeChip />
        </div>

        {active.content}
      </div>
    </DashboardDateRangeProvider>
  );
};

FinancialOverviewPage.route = ReportRoutes.FinancialOverviewPageRouter;

export default FinancialOverviewPage;
